import {
  getDigitalOwlResultEndPoint,
  getDigitalOwlUploadsEndPoint,
  uploadDigitalOwlEndPoint,
} from '../../common/api.endPoints';
import { HttpService } from '../../common/http.service';

export enum DigitalOwlUploadStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface DigitalOwlResultSummary {
  originalFilename: string;
  totalRows: number;
  totalPolicies: number;
  processedCount: number;
  skippedCount: number;
  validationFailedCount: number;
  notFoundCount: number;
  errorCount: number;
  resultS3Key?: string;
}

export interface DigitalOwlJob {
  id: number;
  status: DigitalOwlUploadStatus;
  originalFilename: string;
  uploadedBy: string | null;
  uploadedByUserId: number | null;
  resultSummary: DigitalOwlResultSummary | null;
  errorMessage: string | null;
  createdAt: string;
  startedAt: string | null;
  completedAt: string | null;
}

export const uploadDigitalOwlCsv = async (
  file: File,
): Promise<DigitalOwlJob> => {
  const formData = new FormData();
  formData.append('file', file);
  const data = await HttpService.getInstance().postFiles(
    uploadDigitalOwlEndPoint(),
    formData,
  );
  return data as unknown as DigitalOwlJob;
};

export const downloadDigitalOwlResult = async (
  jobId: number,
): Promise<void> => {
  const response = await HttpService.getInstance().get(
    getDigitalOwlResultEndPoint(jobId),
  );
  const data = (response as any)?.parsedBody ?? response;
  const url = data?.url as string | undefined;
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
};

export const getDigitalOwlUploads = async (
  limit = 10,
): Promise<DigitalOwlJob[]> => {
  const response = await HttpService.getInstance().get(
    `${getDigitalOwlUploadsEndPoint()}?limit=${limit}`,
  );
  const data = (response as any)?.parsedBody ?? response;
  if (!Array.isArray(data)) {
    return [];
  }
  return data as DigitalOwlJob[];
};
